// extracted by mini-css-extract-plugin
export var button = "styles-module--button--WnDwt";
export var iconcontainer = "styles-module--iconcontainer--a7RPi";
export var large = "styles-module--large--Xh+4I";
export var small = "styles-module--small--CAcS3";